export const initFAQ = () => {
  const faqItems = document.querySelectorAll(".faq__item");

  if (faqItems.length === 0) return;

  // пункты внутри [data-faq-group] закрывают только своих соседей, без группы — все на странице
  const groupOf = (item: Element): Element | null =>
    item.closest("[data-faq-group]");

  for (const item of faqItems) {
    item.addEventListener("click", (event) => {
      const { target } = event;

      if ((target as HTMLElement).closest(".faq__item-title")) {
        item.classList.toggle("--opened");
      }

      faqItems.forEach((el) => {
        if (el !== item && groupOf(el) === groupOf(item)) {
          el.classList.remove("--opened");
        }
      });
    });
  }
};
